module.exports = __webpack_public_path__ + "img/arrow-bold.ffa57cc.svg";